// Pure circle predicates used for blast-radius interception.

import type { Vec2 } from '../state/types';
import { dist } from './vec2';

/** True if point `p` lies within (or on) the circle. */
export const containsPoint = (center: Vec2, radius: number, p: Vec2): boolean =>
  dist(center, p) <= radius;

/** True if two circles overlap (or are tangent). */
export const circlesOverlap = (
  c1: Vec2,
  r1: number,
  c2: Vec2,
  r2: number,
): boolean => dist(c1, c2) <= r1 + r2;
